var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-read"},[_c('sub-menu',[_c('menu-item',{attrs:{"link":"/read","exact":""}},[_vm._v("Our Vows")]),_vm._v(" "),_c('menu-item',{attrs:{"link":"/read/phil","exact":""}},[_vm._v("Phil's Reading")])],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61a38bdd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Read.vue
// module id = 58
// module chunks = 0